import { Button } from "@/shared/components/Button";
import { Container } from "@/shared/components/Container";
import { SectionTag } from "@/shared/components/SectionTag";
import { GradientHeading } from "@/shared/components/GradientHeading";
import { Reveal } from "@/shared/components/Reveal";
import { useLocale } from "@/shared/i18n/locale";
import { getHomeContent } from "@/content/home.content";
import styles from "./Workshops.module.css";

/** Site Educação — subdomínio `edu.` (ex.: edu.localhost / edu.autou.com.br). */
const EDUCACAO_SITE_HREF =
  import.meta.env.VITE_PUBLIC_SITE_URL_EDUCACAO?.replace(/\/$/, "") ||
  "http://edu.localhost:8000";

export function Workshops() {
  const locale = useLocale();
  const content = getHomeContent(locale);

  return (
    <section id="educacao" className={styles.workshops}>
      {/* Banda branca estática: cobre o navy do topo da seção. NÃO pode ser
          animada com translateY (o deslocamento expõe o navy como uma faixa). */}
      <div className={styles.leadIn}>
        <Container>
          <div className={styles.leadPill}>
            <svg
              className={styles.leadIcon}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
            </svg>
            <p className={styles.leadText}>
              {content.workshops.leadTextPart1}
              <span className={styles.leadAccent}>{content.workshops.leadAccent}</span>
              {content.workshops.leadTextPart2}
            </p>
          </div>
        </Container>
      </div>

      {/* Corpo navy: começa no banner. A seção em si é branca, então acima do
          pill nunca há navy — elimina o "rasgo" no limite entre as seções. */}
      <div className={styles.body}>
        <Container>
          <div className={`${styles.banner} ${styles.bannerImage}`} aria-hidden />

          <Reveal className={styles.intro}>
            <SectionTag className={styles.introTag} tone="light">
              {content.workshops.tag}
            </SectionTag>
            <GradientHeading className={styles.introTitle}>
              {content.workshops.title}
            </GradientHeading>
            <p className={styles.introText}>
              {content.workshops.introText}
            </p>
          </Reveal>

          <Reveal as="p" className={styles.cta} delay={100}>
            {content.workshops.cta}
            <span className={styles.accent}>{content.workshops.ctaAccent}</span>
          </Reveal>

          <div className={styles.options}>
            {content.workshops.options.map((option, index) => (
              <Reveal
                as="article"
                key={option.id}
                className={styles.option}
                delay={index * 120}
              >
                <div className={styles.optionHeader}>
                  <h3 className={styles.optionTitle}>{option.title}</h3>
                  <p className={styles.optionText}>{option.text}</p>
                  <div className={styles.chips}>
                    {option.chips.map((chip) => (
                      <span key={chip} className={styles.chip}>
                        {chip}
                      </span>
                    ))}
                  </div>
                </div>
                <div>
                  <ul className={styles.list}>
                    {option.items.map((item) => (
                      <li key={item} className={styles.listItem}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className={styles.customProgramCta} delay={140}>
            <Button href={locale === "en" ? `${EDUCACAO_SITE_HREF}/en` : EDUCACAO_SITE_HREF} className={styles.ctaButton}>
              {content.workshops.buttonText}
            </Button>
          </Reveal>

          <Reveal as="p" className={styles.customProgramNote} delay={160}>
            {content.workshops.customProgramNote}
          </Reveal>
        </Container>
      </div>
    </section>
  );
}
